import { Button } from '@printdeal/ui-library';
import clsx from 'clsx';
import React, { useRef, useEffect } from 'react';
import { useRefinementList } from 'react-instantsearch';
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { FilterState, Refinement } from './FacetFilteringBanner';
import { Question } from '../../../services/product-ai/ProductAiService';

type FacetFilteringQuestionProps = {
  index: number;
  question: Question
  filterState: FilterState;
  questionIndex: number;
  callbackHandler: (
    index: number,
    refinement?: Refinement
  ) => void
};

export const FacetFilteringQuestion = ({
  index,
  question,
  filterState,
  questionIndex,
  callbackHandler,
}: FacetFilteringQuestionProps) => {
  const { items, refine } = useRefinementList({ attribute: question.attribute });
  const buttonRef = useRef<Record<string, HTMLButtonElement | null>>({});
  const usableItems = items.filter((item) => question.values.some((option) => option.value === item.value));

  const setRefinement = (item: RefinementListItem) => {
    items.filter((i) => i.isRefined && i.value !== item.value).forEach((i) => refine(i.value));
    if (!item.isRefined) {
      refine(item.value);
    }
    callbackHandler(index, {
      item,
      refine,
    });
  };

  useEffect(() => {
    if (
      items.length < 2
      && questionIndex === index
      && filterState.interacted
      && !filterState.completed) {
      callbackHandler(index);
    }
  }, [
    items,
    index,
    questionIndex,
    filterState,
    callbackHandler,
  ]);

  return (
    <>
      {usableItems.map((item) => (
        <div key={item.value} className={clsx({ 'pd-hidden': questionIndex !== index })}>
          <Button
            ref={(el: HTMLButtonElement) => {
              if (el) buttonRef.current[item.value] = el;
            }}
            onClick={() => {
              setRefinement(item);
            }}
          >
            {item.value}
          </Button>
        </div>
      ))}
    </>
  );
};
